import React from "react";

export type TPerplexityIconProps = React.SVGAttributes<SVGElement>;

export function PerplexityIcon({ ...rest }: TPerplexityIconProps) {
  return (

    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...rest}>
      <g clipPath="url(#clip0_3838_25)">
        <path d="M18.298 0.932L12.0007 7.268H18.298V0.932ZM18.298 0.932V2.66667M11.9861 0V24M18.298 
        13.6027L12.0007 7.26667M18.298 13.6027V22.686L12.0007 16.35M18.298 13.6027L12 7.26667M18.298 
        13.6027L18.2973 16.3133H21V7.26667H12M12.0007 7.26667V16.35M12.0007 7.26667L5.70265 
        13.6027M12.0007 16.35L5.70265 22.686V13.6027M5.70265 13.6027L5.70199 16.3133H3V7.26667H12M5.70265 13.6027L12 
        7.26667M12 7.268L5.70199 0.932V7.268H12Z" stroke="#20808D" strokeMiterlimit="10" />
      </g>
      <defs>
        <clipPath id="clip0_3838_25">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>

  );
}
